import React from 'react'

const AngleBracket = props => (
  <svg viewBox="0 0 10.66 24.29" {...props} fill={props.color}>
    <path
      d="M1.3 24.29A1.29 1.29 0 0 1 .53 24a1.31 1.31 0 0 1-.27-1.83l7.47-10.02L.26 2.08A1.3 1.3 0 1 1 2.35.53l8.05 10.84a1.31 1.31 0 0 1 0 1.55l-8 10.85a1.32 1.32 0 0 1-1.1.52z"
      fill={props.color ? props.color : '#000'}
    />
  </svg>
)

export default AngleBracket



// WEBPACK FOOTER //
// ./src/components/shared/angleBracket.js